import { LogType } from "shared/types";

export function logGenerator(type: LogType["type"], className: string) {
  return (...args: unknown[]) => {
    const prefixedArgs = [`[${className}]`, ...args];
    if (window.flightLogger) {
      window.flightLogger[type](...prefixedArgs);
    } else {
      // eslint-disable-next-line no-console
      console[type](...prefixedArgs);
    }
  };
}

export class BaseLogger {
  static log(...args: unknown[]) {
    logGenerator("log", this.name)(...args);
  }

  static warn(...args: unknown[]) {
    logGenerator("warn", this.name)(...args);
  }

  static error(...args: unknown[]) {
    logGenerator("error", this.name)(...args);
  }
}
